import React from 'react'
import GAEventContextManager from 'shared/components/context/ga-event-manager'
import ModalContextManager from 'shared/components/context/modal-manager'
import ReduxBridgeManager from 'shared/components/context/redux-bridge-manager'
import RefreshDataContextManager from 'shared/components/context/refresh-data-manager'
import EditAPIContextManager from './components/context/edit-api-manager'

const ContextManagers = ({ children }) => (
    <ReduxBridgeManager>
        <GAEventContextManager>
            <RefreshDataContextManager>
                <EditAPIContextManager>
                    <ModalContextManager>{children}</ModalContextManager>
                </EditAPIContextManager>
            </RefreshDataContextManager>
        </GAEventContextManager>
    </ReduxBridgeManager>
)

export default ContextManagers
